/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from 'vue';
import '../hooks/index.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../hooks/icon.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../hooks/slot.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../hooks/tnode.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../hooks/useCommonClassName.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../_chunks/dep-b011b919.mjs';
import '../hooks/useVModel.mjs';

var FORM_CONTROL_COMPONENTS = ["TInput", "TInputNumber", "TTextarea", "TCascader", "TSelect", "TOption", "TSwitch", "TCheckbox", "TCheckboxGroup", "TRadio", "TRadioGroup", "TTreeSelect", "TDatePicker", "TTimePicker", "TUpload", "TTransfer", "TSlider"];
var useCLASSNAMES = function useCLASSNAMES() {
  var classPrefix = usePrefixClass();
  return computed(function () {
    var form = "".concat(classPrefix.value, "-form");
    var input = "".concat(classPrefix.value, "-input");
    var is = "".concat(classPrefix.value, "-is");
    return {
      form: form,
      label: "".concat(form, "__label"),
      labelTop: "".concat(form, "__label--top"),
      inline: "".concat(form, "-inline"),
      formItem: "".concat(form, "__item"),
      formItemWithHelp: "".concat(form, "__item-with-help"),
      formItemWithExtra: "".concat(form, "__item-with-extra"),
      controls: "".concat(form, "__controls"),
      controlsContent: "".concat(form, "__controls-content"),
      status: "".concat(form, "__status"),
      extra: "".concat(input, "__extra"),
      help: "".concat(input, "__help"),
      success: "".concat(is, "-success"),
      successBorder: "".concat(form, "--success-border"),
      error: "".concat(is, "-error"),
      warning: "".concat(is, "-warning")
    };
  });
};
var ValidateStatus = /* @__PURE__ */function (ValidateStatus2) {
  ValidateStatus2["TO_BE_VALIDATED"] = "not";
  ValidateStatus2["SUCCESS"] = "success";
  ValidateStatus2["FAIL"] = "fail";
  return ValidateStatus2;
}(ValidateStatus || {});
var FormInjectionKey = Symbol("FormProvide");
var FormItemInjectionKey = Symbol("FormItemProvide");

export { FORM_CONTROL_COMPONENTS, FormInjectionKey, FormItemInjectionKey, ValidateStatus, useCLASSNAMES };
//# sourceMappingURL=const.mjs.map
